<template>
  <footer>
    <nav class="footerMenuContainer">
      <ul>
        <li>
          <router-link v-bind:to="{ name: 'KahiMap' }" v-slot="{ isActive }"
            ><span
              ><footer-menu-icon-map
                v-bind:active="isActive"
              ></footer-menu-icon-map></span
          ></router-link>
        </li>
        <li>
          <router-link v-bind:to="{ name: 'KahiList' }" v-slot="{ isActive }"
            ><span
              ><footer-menu-icon-list
                v-bind:active="isActive"
              ></footer-menu-icon-list></span
          ></router-link>
        </li>
      </ul>
    </nav>
  </footer>
</template>

<script lang="ts" src="./AppFooter.ts"></script>
<style scoped lang="scss" src="./AppFooter.scss"></style>
